var OtpField = /** @class */ (function () {
    function OtpField() {
        var _this = this;
        this.host = null;
        this.hiddenInput = null;
        this.cells = [];
        this.length = 4;
        this.initialized = false;
        this.autoSubmit = false; // when true, submit enclosing form once all digits are entered
        this.autoSubmitTriggered = false; // guard against duplicate submits
        /** Keep bound handlers so we could support a future dispose() */
        this.onInputHandler = function (e) { return _this.onInput(e); };
        this.onKeyDownHandler = function (e) { return _this.onKeyDown(e); };
        this.onPasteHandler = function (e) { return _this.onPaste(e); };
        this.onFocusHandler = function (e) { return _this.onFocus(e); };
    }
    /**
     * Initialize OTP field behavior on the element with the given id or the element itself.
     * Subsequent calls are ignored (idempotent) unless forceReinit = true.
     */
    OtpField.prototype.init = function (idOrElement, forceReinit) {
        var _this = this;
        if (forceReinit === void 0) { forceReinit = false; }
        var host = typeof idOrElement === 'string' ? document.getElementById(idOrElement) : idOrElement;
        if (!host)
            return;
        // Prevent double init (mirrors __otpInited flag logic from inline script)
        if (host.__otpInited && !forceReinit)
            return;
        host.__otpInited = true;
        this.host = host;
        this.length = Math.max(1, parseInt(host.getAttribute('data-otp-length') || '4', 10));
        var autoAttr = host.getAttribute('data-otp-auto-submit');
        this.autoSubmit = (autoAttr || '').toLowerCase() === 'true';
        var hiddenId = host.getAttribute('data-otp-hidden');
        this.hiddenInput = hiddenId ? document.getElementById(hiddenId) : null;
        this.cells = Array.from(host.querySelectorAll('.otp-cell-input'));
        this.cells.forEach(function (inp, idx) { return inp.setAttribute('data-idx', String(idx)); });
        // Attach listeners
        this.cells.forEach(function (inp) {
            inp.addEventListener('input', _this.onInputHandler);
            inp.addEventListener('keydown', _this.onKeyDownHandler);
            inp.addEventListener('paste', _this.onPasteHandler);
            inp.addEventListener('focus', _this.onFocusHandler);
        });
        this.setHidden();
        this.initialized = true;
    };
    /** Optional teardown if needed externally */
    OtpField.prototype.dispose = function () {
        var _this = this;
        if (!this.host || !this.initialized)
            return;
        this.cells.forEach(function (inp) {
            inp.removeEventListener('input', _this.onInputHandler);
            inp.removeEventListener('keydown', _this.onKeyDownHandler);
            inp.removeEventListener('paste', _this.onPasteHandler);
            inp.removeEventListener('focus', _this.onFocusHandler);
        });
        this.initialized = false;
    };
    OtpField.prototype.onlyDigits = function (s) { return (s || '').replace(/\D+/g, ''); };
    OtpField.prototype.focusIdx = function (i) { if (i >= 0 && i < this.cells.length)
        this.cells[i].focus(); };
    OtpField.prototype.joinValue = function () { return this.cells.map(function (i) { return i.value; }).join(''); };
    OtpField.prototype.setHidden = function () {
        if (!this.hiddenInput)
            return;
        var joined = this.joinValue();
        this.hiddenInput.value = joined;
        var host = this.host;
        if (!host)
            return;
        var raw = host.getAttribute('data-otp-blazor-event') || 'onchange';
        var evtName = raw.startsWith('on') ? raw.slice(2) : raw; // oninput -> input
        this.hiddenInput.dispatchEvent(new Event(evtName, { bubbles: true }));
        // Auto submit logic (works for plain HTML forms & Blazor EditForm)
        if (this.autoSubmit) {
            if (joined.length === this.length) {
                if (!this.autoSubmitTriggered) {
                    this.autoSubmitTriggered = true; // set early to avoid double triggers
                    var form_1 = this.hiddenInput.form || host.closest('form');
                    if (form_1) {
                        // Defer to allow any pending model binding events to process first
                        setTimeout(function () {
                            try {
                                // Prefer requestSubmit to fire submit event / validation
                                form_1.requestSubmit ? form_1.requestSubmit() : form_1.submit();
                            }
                            catch ( /* swallow */_a) { /* swallow */ }
                        }, 0);
                    }
                }
            }
            else {
                // Reset guard if user edits back to incomplete state
                this.autoSubmitTriggered = false;
            }
        }
    };
    /** Replicates distributeFrom logic from script */
    OtpField.prototype.distributeFrom = function (startIdx, s) {
        var p = 0;
        for (var i = startIdx; i < this.cells.length && p < s.length; i++, p++)
            this.cells[i].value = s[p];
        for (var i = 0; i < startIdx && p < s.length; i++, p++)
            this.cells[i].value = s[p];
        var firstEmpty = this.cells.findIndex(function (inp) { return inp.value === ''; });
        this.focusIdx(firstEmpty === -1 ? this.cells.length - 1 : firstEmpty);
        this.setHidden();
    };
    OtpField.prototype.onInput = function (e) {
        var t = e.target;
        if (!(t instanceof HTMLInputElement))
            return;
        var idx = parseInt(t.getAttribute('data-idx') || '0', 10);
        var v = this.onlyDigits(t.value);
        if (v.length === 0) {
            t.value = '';
            this.setHidden();
            return;
        }
        if (v.length > 1) {
            this.distributeFrom(idx, v.slice(0, this.length));
        }
        else {
            t.value = v;
            if (v && idx < this.cells.length - 1)
                this.focusIdx(idx + 1);
            this.setHidden();
        }
    };
    OtpField.prototype.onKeyDown = function (e) {
        var t = e.target;
        if (!(t instanceof HTMLInputElement))
            return;
        var idx = parseInt(t.getAttribute('data-idx') || '0', 10);
        if ((e.metaKey || e.ctrlKey) && ['v', 'V', 'a', 'c', 'x'].includes(e.key))
            return;
        switch (e.key) {
            case 'Backspace':
                if (t.value === '') {
                    if (idx > 0) {
                        var prev = this.cells[idx - 1];
                        prev.value = '';
                        prev.focus();
                        e.preventDefault();
                    }
                }
                else {
                    t.value = '';
                }
                this.setHidden();
                break;
            case 'Delete':
                t.value = '';
                this.setHidden();
                break;
            case 'ArrowLeft':
                if (idx > 0) {
                    this.focusIdx(idx - 1);
                    e.preventDefault();
                }
                break;
            case 'ArrowRight':
                if (idx < this.cells.length - 1) {
                    this.focusIdx(idx + 1);
                    e.preventDefault();
                }
                break;
            default:
                if (e.key.length === 1 && !/\d/.test(e.key) && !e.metaKey && !e.ctrlKey && !e.altKey) {
                    e.preventDefault();
                }
                break;
        }
    };
    OtpField.prototype.onPaste = function (e) {
        var t = e.target;
        if (!(t instanceof HTMLInputElement))
            return;
        var idx = parseInt(t.getAttribute('data-idx') || '0', 10);
        var cd = e.clipboardData || window.clipboardData;
        var text = cd ? cd.getData('text') : '';
        var digits = this.onlyDigits(text);
        if (!digits)
            return;
        e.preventDefault();
        this.distributeFrom(idx, digits.slice(0, this.length));
        this.setHidden();
    };
    OtpField.prototype.onFocus = function (e) {
        var t = e.target;
        if (t instanceof HTMLInputElement)
            t.select();
    };
    OtpField.create = function () { return new OtpField(); };
    return OtpField;
}());
export { OtpField };
